var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEarly = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolationsmodus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44.21 44.21",
    style: {
      enableBackground: "new 0 0 44.21 44.21"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#88A4AE;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.1,13.96c-4.48,0-8.13,3.65-8.13,8.14s3.64,8.14,8.13,8.14s8.14-3.65,8.14-8.14S26.6,13.96,22.1,13.96z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.91,10.03L20.91,10.03c0.34,0.24,0.75,0.39,1.19,0.39c0.45,0,0.86-0.15,1.19-0.39 c0.5-0.36,0.82-0.95,0.82-1.6V2c0-1.1-0.9-2-2.01-2c-1.09,0-2,0.89-2,2v6.43C20.1,9.09,20.42,9.66,20.91,10.03z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.02,13.85c0.39,0.39,0.9,0.58,1.41,0.58c0.1,0,0.2-0.01,0.3-0.02c0.41-0.06,0.81-0.24,1.12-0.56 c0.32-0.32,0.51-0.71,0.56-1.13c0.1-0.61-0.1-1.24-0.56-1.7L9.31,6.47c-0.79-0.79-2.05-0.79-2.84,0c-0.78,0.78-0.78,2.05,0,2.83 L11.02,13.85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,24.1h6.43c0.66,0,1.24-0.32,1.6-0.81v-0.01c0.25-0.33,0.39-0.73,0.39-1.18s-0.14-0.85-0.39-1.18v-0.01 c-0.36-0.49-0.95-0.81-1.6-0.81H2c-1.1,0-2,0.89-2,2S0.9,24.1,2,24.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.02,30.36l-4.55,4.55c-0.78,0.78-0.78,2.05,0,2.83c0.39,0.39,0.9,0.58,1.41,0.58c0.52,0,1.03-0.19,1.42-0.58 l4.54-4.55c0.47-0.46,0.66-1.09,0.56-1.7c-0.05-0.41-0.24-0.81-0.56-1.13c-0.31-0.31-0.7-0.5-1.12-0.55 C12.13,29.71,11.49,29.89,11.02,30.36z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.29,34.17c-0.33-0.24-0.74-0.39-1.19-0.39c-0.44,0-0.85,0.15-1.18,0.39h-0.01c-0.49,0.37-0.81,0.95-0.81,1.6 v6.43c0,1.1,0.9,2.01,2,2.01s2.01-0.9,2.01-2.01v-6.43C24.11,35.12,23.79,34.53,23.29,34.17z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.19,30.36c-0.47-0.47-1.1-0.65-1.71-0.55c-0.4,0.05-0.8,0.24-1.12,0.55c-0.32,0.32-0.5,0.71-0.56,1.12 c-0.1,0.61,0.1,1.24,0.56,1.71l4.54,4.55c0.39,0.39,0.9,0.58,1.42,0.58c0.51,0,1.02-0.19,1.41-0.58c0.78-0.78,0.78-2.04,0-2.83 L33.19,30.36z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.21,20.1h-6.43c-0.66,0-1.24,0.32-1.6,0.81v0.01c-0.25,0.33-0.39,0.73-0.39,1.18s0.14,0.85,0.39,1.18v0.01 c0.36,0.49,0.95,0.81,1.6,0.81h6.43c1.1,0,2-0.89,2-2S43.32,20.1,42.21,20.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.37,13.85c0.31,0.32,0.7,0.5,1.12,0.56c0.1,0.01,0.2,0.02,0.3,0.02c0.51,0,1.02-0.19,1.41-0.58l4.55-4.55 c0.78-0.78,0.78-2.05,0-2.83c-0.79-0.79-2.05-0.79-2.84,0l-4.54,4.55c-0.47,0.47-0.66,1.1-0.56,1.71 C29.87,13.13,30.05,13.53,30.37,13.85z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEarly);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/early.fddc796751b7d2ce099aa5c6fb44121d.svg";